const homeRoute = 'defects'

const routes = [{
	path: '/auth',
	name: 'auth',
	component: () => import('../views/Auth.vue'),
	meta: {
		guest: true,
		layout: 'no-navbar',
		showInNavbar: false
	}
}, {
	path: '/forget',
	name: 'Forget',
	component: () => import('../views/Forget.vue'),
	meta: {
		guest: true,
		layout: 'no-navbar',
		showInNavbar: false
	}
}, {
	path: '/resetpassword',
	name: 'Reset',
	component: () => import('../views/ResetPassword.vue'),
	meta: {
		guest: true,
		layout: 'no-navbar',
		showInNavbar: false
	}
}, {
	path: '/',
	name: 'landing',
	redirect: {
		name: homeRoute,
		showInNavbar: false
	}
}, {
	path: '/video-report',
	name: 'videoReport',
	label: "Export Video Report",
	component: () => import('../views/VideoReport.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: false
	}
}, {
	path: '/defects',
	name: 'defects',
	label: "Defects",
	icon: ["fas", "exclamation-triangle"],
	component: () => import('../views/Defects.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: true
	}
},
// {
// 	path: '/tracking',
// 	name: 'tracking',
// 	label: "Tracking",
// 	icon: ["fas", "search-location"],
// 	component: () => import('../views/Tracking.vue'),
// 	meta: {
// 		requiresAuth: true,
// 		// roleRestricted: ["JKR District", "JKR"],
// 		showInNavbar: true
// 	}
// },
//  {
// 	path: '/social',
// 	name: 'social',
// 	label: "Social",
// 	icon: ["fas", "comment-alt"],
// 	component: () => import('../views/Social.vue'),
// 	meta: {
// 		requiresAuth: true,
// 		showInNavbar: true
// 	}
// }, {
// 	path: '/complaints',
// 	name: 'complaints',
// 	label: "Complaints",
// 	icon: ["fas", "comments"],
// 	component: () => import('../views/Complaints.vue'),
// 	meta: {
// 		requiresAuth: true,
// 		showInNavbar: true
// 	}
// }, 
{
	path: '/cases/:id?',
	name: 'cases',
	label: "Cases",
	icon: ["fas", "hard-hat"],
	component: () => import('../views/Cases.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: true
	}
}, {
	path: '/gallery',
	name: 'gallery',
	label: "Gallery",
	icon: ["fas", "images"],
	component: () => import('../views/Gallery.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: true
	}
}, {
	path: '/reports',
	name: 'reports',
	label: "Reports",
	icon: ["fas", "file-invoice"],
	component: () => import('../views/Reports.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: true
	}
}, {
	path: '/dashcam',
	name: 'dashcam',
	label: "Dashcam",
	icon: ["fas", "video"],
	component: () => import('../views/Dashcam.vue'),
	meta: {
		requiresAuth: true,
		roleRestricted: ["Command Center"],
		showInNavbar: true
	}
}, {
	path: '/drone',
	name: 'drone',
	label: "Drone",
	icon: ["fas", "helicopter"],
	component: () => import('../views/Drone.vue'),
	meta: {
		requiresAuth: true,
		roleRestricted: ["Command Center"],
		showInNavbar: true
	}
},
// {
// 	path: '/trams',
// 	name: 'trams',
// 	label: "PCA",
// 	icon: ["fas", "car"],
// 	component: () => import('../views/Trams.vue'),
// 	meta: {
// 		requiresAuth: true,
// 		roleRestricted: ["Command Center"],
// 		showInNavbar: true
// 	}
// }, 
{
	path: '/live',
	name: 'live',
	component: () => import('../views/Live.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: true,
		showInNavbar: false
	}
}, {
	path: '/inspection',
	name: 'inspection',
	component: () => import('../views/Inspection.vue'),
	meta: {
		requiresAuth: true,
		roleRestricted: ["Supervisor", "Command Center"],
		showInNavbar: false
	}
}, {
	path: '/upload',
	name: 'upload',
	component: () => import('../views/Upload.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: false
	}
}, {
	path: '/users',
	name: 'users',
	component: () => import('../views/UserList.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: false
	}
}, {
	path: '/tenders',
	name: 'tenders',
	label: "Sebut Harga",
	icon: ["fas", "file-invoice-dollar"],
	component: () => import('../views/Tender.vue'),
	meta: {
		requiresAuth: true,
		roleRestricted: [
			"Command Center",
			"JKR",
			"JKR District",
			"Authenticated",
			"KKE",
			"Supervisor",
			"Super Admin",
		],
		showInNavbar: false
	}
}, {
	path: '/logs',
	name: 'logs',
	component: () => import('../views/UserLogs.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: false
	}
}, {
	path: '/case-logs',
	name: 'caseDeleteLogs',
	component: () => import('../views/CaseDeleteLogs.vue'),
	meta: {
		requiresAuth: true,
		showInNavbar: false,
		roleRestricted: [
			"Command Center",
			"JKR",
			"JKR District",
			"Authenticated",
			"KKE",
			"Supervisor",
		],
	}
}]

export {
	homeRoute,
	routes
}